export const convertToUTF = (innerHTML: string) => {
  const element = document.createElement('div');
  element.innerHTML = innerHTML;
  
  return element.innerText;
};
